/**
 * Numeric contribution of an item effect line for build totals.
 * Prefers `value` when the API sends normalized scalars (Item.to_dict()).
 * Falls back to min/max using the same rules as backend `pick_effect_value`
 * (DofusDB fixed lines as X/0 or −1/0, real ranges via max(min, max)).
 */
export function itemEffectNumericValue(effect) {
    if (!effect || typeof effect !== 'object') return NaN;
    if (effect.value !== undefined && effect.value !== null) {
        const v = Number(effect.value);
        if (Number.isFinite(v)) return v;
    }
    const hasMin = effect.min !== undefined && effect.min !== null;
    const hasMax = effect.max !== undefined && effect.max !== null;
    const nMin = hasMin ? Number(effect.min) : NaN;
    const nMax = hasMax ? Number(effect.max) : NaN;
    const finMin = Number.isFinite(nMin) ? nMin : null;
    const finMax = Number.isFinite(nMax) ? nMax : null;
    if (finMin !== null && finMax !== null) {
        if (finMin === 0 && finMax === 0) return 0;
        if (finMin === 0 && finMax !== 0) return finMax;
        if (finMax === 0 && finMin !== 0) return finMin;
        return Math.max(finMin, finMax);
    }
    if (finMax !== null) return finMax;
    if (finMin !== null) return finMin;
    return NaN;
}
